import { Building2 } from 'lucide-react';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Post-signup optional Procore connect (ISS-183 Phase E). Not named Procore* — LD-1.
 */
export default function ProcoreConnectPrompt({ connectHref, onSkip }) {
  return (
    <section
      className="mt-6 rounded-2xl border border-black/10 bg-[#F6F5F2] p-6 text-left shadow-sm"
      aria-labelledby="procore-connect-heading"
    >
      <div className="flex items-start gap-3 mb-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#FF6A00]/12 text-[#FF6A00]">
          <Building2 className="h-5 w-5" aria-hidden />
        </div>
        <div>
          <h2
            id="procore-connect-heading"
            className="text-base font-semibold text-[#1C1C1E]"
          >
            Connect Procore (optional)
          </h2>
          <p className="mt-1 text-sm text-slate-600 leading-relaxed">
            Link your Procore company to pull projects and roster data into Virtual
            Hardhat. You can also connect later from Settings.
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-3 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={onSkip}
          className="order-2 sm:order-1 rounded-xl border border-black/15 px-4 py-3 text-sm font-semibold text-slate-700 transition-colors hover:bg-black/[0.04] hover:text-[#1C1C1E]"
        >
          Skip for now
        </button>
        <a
          href={connectHref}
          className="order-1 sm:order-2 inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-orange-600 to-orange-500 px-4 py-3 text-sm font-semibold text-white shadow-lg shadow-orange-900/30 transition-transform hover:scale-[1.02]"
        >
          Connect Procore
        </a>
      </div>
    </section>
  );
}

ProcoreConnectPrompt.propTypes = {
  connectHref: PropTypes.string.isRequired,
  onSkip: PropTypes.func.isRequired,
};
